import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  SecurityService,
  OrderSecurity,
  TransfersTab,
  DataAnalyticsTaggingEvent,
  DataAnalyticsTaggingConstants
} from '@tdwb/core';

import { DisplayLearnInformation } from '../../domain';

@Component({
  selector: 'td-wb-trading-learn-information',
  templateUrl: './trading-learn-information.component.html',
  styleUrls: ['./trading-learn-information.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TradingLearnInformationComponent {
  @Input() tabId: OrderSecurity | TransfersTab = 'equity';
  @Input() page: DisplayLearnInformation =  'buysell';

  eventData: DataAnalyticsTaggingEvent;

  constructor(private securityService: SecurityService) {}

  showTradingLearnInformation(): boolean {
    return this.securityService.hasPermission('DIRECT_INVESTING');
  }

  setAnalytics(): void{
    this.eventData =
      DataAnalyticsTaggingConstants.getLinkClickEventData('tdw:wbt:ofi:transfer:learn now');
  }
}
